import React, { useEffect, useRef, useState } from "react";
import Close from './../assets/images/close_icon.svg'
import InputFields from "../components/InputFields";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt, FaUser, FaPhone, FaMapMarkerAlt, FaCalendarDay, FaClipboardList } from 'react-icons/fa';
import { useAddOrder, useGetAllFarms, useUpdateOrder } from "../hooks/hooks";

import { showSuccessToast } from './../components/common'
import { useTranslation } from "react-i18next";
import SearchSelectFarms from "../components/SearchSelectFarms";
import useOutsideClick from "../hooks/useOutsideClick";
import SelectPhoneNew from "./SelectPhoneNew";
import { PhoneNumberUtil } from "google-libphonenumber";
import ReactDOM from "react-dom";
import moment from "moment";
import { DropdownIcon, ErrorIcon, LoadingIcon, LowStockIcon } from "../assets/icons/icon";
import { ButtonWithIcon } from "../components/Common/Buttons";

const AddOrder = ({ isOpen, onClose, isEdit, isEditItem }) => {
  const { t } = useTranslation();
  const datePickerRef = useRef(null);
  const [inputValue, setInputValue] = useState({ partyName: "", contactNumber: "", farmName: '', farmAddress: '', eventDate: '', farm: {}, status: null, phone: "" });
  const [Error, setError] = useState({ partyName: "", contactNumber: '', farmName: "", farmAddress: "", eventDate: '', status: "", phone: "" });
  const [inputMobileData, setInputMobileData] = useState({
    country_code: '',
    phone_number: '',
  });

  const statusList = [
    { id: 1, name: 'In-progress', color: 'bg-red-100 text-red-800' },
    { id: 2, name: 'Completed', color: 'bg-green-100 text-green-800' },
    { id: 3, name: 'Upcoming', color: 'bg-blue-100 text-blue-800' },
    { id: 4, name: 'Cancel', color: 'bg-yellow-100 text-yellow-800' }
  ];

  const [startDate, setStartDate] = useState(null);

  const { mutate: addOrder } = useAddOrder();
  const { mutate: updateOrder } = useUpdateOrder();
  const { data: allFarms, refetch } = useGetAllFarms();

  const [isPopover, setIsPopover] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showCloseConfirmation, setShowCloseConfirmation] = useState(false);

  const popoverRef = useRef(null);

  // Remove the useOutsideClick hook and use a different approach
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target) && isPopover) {
        setIsPopover(false);
      }
    };

    if (isPopover) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isPopover]);

  const phoneUtil = PhoneNumberUtil.getInstance();

  const isPhoneValid = (phone) => {
    try {
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (error) {
      return false;
    }
  };


  useEffect(() => {
    if (isEdit && isEditItem) {
      setInputValue({
        partyName: isEditItem.partyName || "",
        contactNumber: isEditItem.contactNumber || '',
        farmName: isEditItem.farmName || "",
        farmAddress: isEditItem.farmAddress || "",
        eventDate: isEditItem.eventDate || "",
        farm: isEditItem.farm || {},
        status: isEditItem.status || null,
        phone: isEditItem.contactNumber || ''
      });
      setStartDate(isEditItem.eventDate);
      setInputMobileData((prevData) => ({
        ...prevData,
        phone_number: isEditItem.contactNumber, // Update the phone_number field
      }));
    }
  }, [isEdit, isEditItem]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue({
      ...inputValue,
      [name]: value.toString(),
    });
    setError({ ...Error, partyName: "", farmName: "", farmAddress: "", eventDate: '', phone: '' });
  };

  const handleChangePhone = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 10) value = value.slice(0, 10);
    setInputValue({ ...inputValue, contactNumber: value });
    setError({ ...Error, partyName: "", farmName: "", farmAddress: "", eventDate: '' });
  };

  const handleBlur = (e) => {
    const value = e.target.value;
    if (value.length > 0 && value.length !== 10) {
      setError({ ...Error, contactNumber: t('Mobile_Number_Er') });
    }
  };

  const onSubmit = () => {
    const isValid = isPhoneValid(inputValue.contactNumber)
    if (inputValue.partyName.toString().trim() === "") {
      setError({ ...Error, partyName: t('Party_Name_Er') });
      return;
    }

    if (inputValue.phone.toString().trim() === "") {
      setError({ ...Error, phone: t('Contact_Number_Er') });
      return;
    }

    if (inputValue.phone.toString().trim() === "") {
      setError({ ...Error, phone: 'Please enter phone number' });
      return;
    }

    const phoneRegex = /^(\+91|91)?[6-9]\d{9}$/;
    const cleanPhone = inputValue.phone.replace(/\s+/g, '').replace(/[^\d+]/g, '');

    if (!phoneRegex.test(cleanPhone)) {
      setError({ ...Error, phone: 'Please enter a valid phone number (10 digits starting with 6-9)' });
      return;
    }

    // if (!isValid) {
    //     setError({ ...Error, contactNumber: t('Contact_Valid_Er') });
    //     return;
    // }

    // if (inputValue.farmName.toString().trim() === "") {
    //     setError({ ...Error, farmName: t('Farm_Name_Er') });
    //     return;
    // }

    // if (inputValue.farmAddress.toString().trim() === "") {
    //     setError({ ...Error, farmAddress: t('Farm_Adderess_Er') });
    //     return;
    // }

    // inputValue.eventDate = startDate;
    const date = moment(startDate).format("YYYY-MM-DD");
    inputValue.eventDate = moment.utc(date, "YYYY-MM-DD").toISOString();
    inputValue.contactNumber = inputValue.phone;


    setIsLoading(true);
    if (isEdit) {

      const updateItem = {
        ...inputValue,
        _id: isEditItem._id
      }
      updateOrder(updateItem, {
        onSuccess: (res) => {
          showSuccessToast(res?.data?.message);
          onClose(true);
          setIsLoading(false);
          setError({ ...Error, name: '' });
        },
        onError: (err) => {
          setIsLoading(false);
          setError({ ...Error, all: err.response.data.error });
        },
      });
    } else {
      addOrder(inputValue, {
        onSuccess: (res) => {
          showSuccessToast(res?.data?.message);
          onClose(true);
          setIsLoading(false);
          setError({ ...Error, name: '' });
        },
        onError: (err) => {
          setIsLoading(false);
          setError({ ...Error, all: err.response.data.error });
        },
      });
    }

  }

  const getStatusColor = (statusId) => {
    const status = statusList.find(s => s.id === statusId);
    return status ? status.color : 'bg-gray-100 text-gray-800';
  };

  // Check if form has any data
  const hasFormData = () => {
    const hasData = (
      inputValue.partyName?.trim() !== "" ||
      inputValue.farmName?.trim() !== "" ||
      inputValue.farmAddress?.trim() !== "" ||
      inputValue.status !== null ||
      startDate !== null
    );
    return hasData;
  };

  // Handle close with confirmation
  const handleClose = () => {
    if (hasFormData()) {
      setShowCloseConfirmation(true);
    } else {
      onClose(false);
      setError({ ...Error, partyName: "", farmName: "", farmAddress: "", eventDate: '' });
    }
  };

  // Confirm close and reset form
  const confirmClose = () => {
    setShowCloseConfirmation(false);
    onClose(false);
    setError({ ...Error, partyName: "", farmName: "", farmAddress: "", eventDate: '' });
    // Reset form data
    setInputValue({ partyName: "", contactNumber: "", farmName: '', farmAddress: '', eventDate: '', farm: {}, status: null });
    setStartDate(null);
    setInputMobileData({ country_code: '', phone_number: '' });
  };

  // Cancel close
  const cancelClose = () => {
    setShowCloseConfirmation(false);
  };

  return (
    <>
      {isOpen && (
        <div className="popup-overlay">
          <div
            className="popup-content !w-[800px] max-h-[90vh] flex flex-col"
          // Remove stopPropagation to allow outside clicks
          >
            {/* Fixed Header */}
            <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-white rounded-t-lg flex-shrink-0">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-secondary rounded-full flex items-center justify-center">
                  <FaClipboardList className="text-white text-lg" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold text-gray-800">
                    {isEdit ? t('Update_order') : t('add_new_order')}
                  </h2>
                  <p className="text-sm text-gray-500">
                    {isEdit ? t('update_existing_order_lbl') : t('create_new_order_lbl')}
                  </p>
                </div>
              </div>
              <button
                className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
                onClick={handleClose}
              >
                <img src={Close} alt="Close" className="w-5 h-5" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto p-4 space-y-6">
              {/* Party Information Section */}
              {/* bg-blue-50 */}
              <div className="border rounded-lg p-4">
                <h3 className="text-lg font-medium text-blue-900 mb-4 flex items-center">
                  <FaUser className="mr-2" />
                  {t('party_information')}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t('Party_Name')} *
                    </label>
                    <div className="relative">
                      <InputFields
                        name="partyName"
                        label="Party Name"
                        type="text"
                        placeholder={t('pl_partyname')}
                        isHideLabel="false"
                        isFixedLabel="true"
                        disabled={isLoading}
                        handleChange={(e) => handleChange(e)}
                        value={inputValue?.partyName}
                        className="text-input w-full h-[50px] px-4 text-[16px] font-[500] text-secondary rounded-lg bg-white border border-gray-300 focus:border-secondary focus:ring-2 focus:ring-secondary/20 transition-all duration-200"
                      />
                    </div>
                    {Error?.partyName && (
                      <div className="text-red-500 text-sm mt-1 flex items-center">
                        <span className="w-1 h-1 bg-red-500 rounded-full mr-2"></span>
                        {Error?.partyName}
                      </div>
                    )}
                  </div>

                  {/* Phone - Full Width */}
                  <div className="">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t('Contact_Number')} *
                    </label>
                    <div className="relative">
                      {/* <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a2 2 0 011.94 1.516l.72 3.24a2 2 0 01-.54 1.94l-1.2 1.2a16 16 0 007.07 7.07l1.2-1.2a2 2 0 011.94-.54l3.24.72A2 2 0 0121 18.72V22a2 2 0 01-2 2h-1C9.163 24 2 16.837 2 8V7a2 2 0 011-1.732z" />
                                                </svg>
                                            </div> */}
                      <InputFields
                        name="phone"
                        label="Phone"
                        type="text"
                        placeholder={t('Contact_Number')}
                        isHideLabel="true"
                        disabled={isLoading}
                        handleChange={(e) => handleChange(e)}
                        value={inputValue?.phone}
                        className="text-input w-full h-[50px] px-4 text-[16px] font-[500] text-secondary rounded-lg bg-white border border-gray-300 focus:border-secondary focus:ring-2 focus:ring-secondary/20 transition-all duration-200"
                      />

                    </div>
                    {Error?.phone && (
                      <p className="mt-2 text-sm text-red-400 flex items-center">
                        <ErrorIcon className='mr-1' />
                        {Error?.phone}
                      </p>
                    )}
                  </div>

                  {/* <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            {t('Contact_Number')} *
                                        </label>
                                        <div className="relative">
                                            <SelectPhoneNew
                                                inputMobileData={inputMobileData}
                                                setInputValue={setInputMobileData}
                                                setErrors={setError}
                                                detectedCountry='IN'
                                                inputValueA={inputValue}
                                                setInputValueA={setInputValue}
                                            />
                                        </div>
                                        {Error?.contactNumber && (
                                            <div className="text-red-500 text-sm mt-1 flex items-center">
                                                <span className="w-1 h-1 bg-red-500 rounded-full mr-2"></span>
                                                {Error?.contactNumber}
                                            </div>
                                        )}
                                    </div> */}
                </div>
              </div>

              {/* Farm Information Section */}
              {/* bg-green-50 */}
              <div className="border rounded-lg p-4">
                <h3 className="text-lg font-medium text-green-900 mb-4 flex items-center">
                  <FaMapMarkerAlt className="mr-2" />
                  {t('farm_information')}
                </h3>
                <div className="space-y-4">
                  <SearchSelectFarms
                    refe={popoverRef}
                    farmList={allFarms}
                    inputValue={inputValue}
                    setInputValue={setInputValue}
                    refetch={refetch}
                    isPopover={isPopover}
                    setIsPopover={setIsPopover}
                  />
                </div>
              </div>

              {/* Event Details Section */}
              {/* bg-purple-50 */}
              <div className="border rounded-lg p-4">
                <h3 className="text-lg font-medium text-purple-900 mb-4 flex items-center">
                  <FaCalendarDay className="mr-2" />
                  {t('event_information')}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t('Event_Date')} *
                    </label>
                    <div className="relative">
                      <DatePicker
                        className="w-full h-[50px] px-4 rounded-lg bg-white border border-gray-300 focus:border-secondary focus:ring-2 focus:ring-secondary/20 transition-all duration-200 text-[16px] font-[500] text-secondary"
                        selected={startDate}
                        placeholder="Date"
                        onChange={(date) => {
                          setStartDate(date)
                        }
                        }
                        placeholderText={t('pl_eventdate')}
                        ref={datePickerRef}
                        dateFormat="dd/MM/yyyy"
                        minDate={new Date()}
                      />
                      <FaCalendarAlt className="absolute top-1/2 right-4 transform -translate-y-1/2 text-gray-400 cursor-pointer"
                        onClick={() => datePickerRef.current.setFocus()}
                      />
                    </div>
                    {Error?.eventDate && (
                      <div className="text-red-500 text-sm mt-1 flex items-center">
                        <span className="w-1 h-1 bg-red-500 rounded-full mr-2"></span>
                        {Error?.eventDate}
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t('status')} *
                    </label>
                    <div className="relative">
                      <select
                        name="status"
                        value={inputValue.status || ""}
                        onChange={handleChange}
                        className="w-full h-[50px] px-4 rounded-lg bg-white border border-gray-300 focus:border-secondary focus:ring-2 focus:ring-secondary/20 transition-all duration-200 text-[16px] font-[500] text-secondary appearance-none cursor-pointer focus-within:outline-0"
                      >
                        <option value="" disabled>{t('select_options')}</option>
                        {statusList && statusList.map((status) => (
                          <option key={status.id} value={status.id}>
                            {status.name}
                          </option>
                        ))}
                      </select>
                      <DropdownIcon className="absolute top-1/2 right-4 transform -translate-y-1/2 pointer-events-none" />
                    </div>
                    {inputValue.status && (
                      <div className="mt-2">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(inputValue.status)}`}>
                          {statusList.find(s => s.id === inputValue.status)?.name}
                        </span>
                      </div>
                    )}
                    {Error?.status && (
                      <div className="text-red-500 text-sm mt-1 flex items-center">
                        <span className="w-1 h-1 bg-red-500 rounded-full mr-2"></span>
                        {Error?.status}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Fixed Footer */}
            <div className="flex justify-end space-x-4 p-4 border-t border-gray-200 bg-white rounded-b-lg flex-shrink-0">
              <ButtonWithIcon text={t('btnCancel')} variant="commonBtn" btnclass="" onClick={handleClose} disabled={isLoading} />
              <ButtonWithIcon text={isEdit ? t('btnUpdate') : t('btnSave')} variant="secondary" btnclass="px-8 py-3 bg-secondary hover:bg-secondary/90 space-x-2 disabled:opacity-50" onClick={onSubmit} disabled={isLoading} isLoading={isLoading} />
            </div>
          </div>
        </div>
      )}

      {showCloseConfirmation &&
        ReactDOM.createPortal(
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[99999999]">
            <div className="bg-white rounded-xl shadow-2xl p-6 max-w-md mx-4 transform transition-all duration-200 scale-100">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center mr-3">
                  <LowStockIcon className={"w-6 h-6 text-yellow-600"} />
                </div>
                <h3 className="text-lg font-semibold text-gray-900">
                  Confirm Close
                </h3>
              </div>
              <p className="text-gray-600 mb-6">
                You have unsaved changes. Are you sure you want to close this form?
              </p>
              <div className="flex justify-end space-x-3">
                <button
                  onClick={cancelClose}
                  className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors duration-200"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmClose}
                  className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors duration-200"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
          ,
          document.body
        )
      }
    </>
  )
}

export default AddOrder;
